<template>
  <div>
    <div class="container" id="take">
      <h2 class="text-center header-font">Program Structure</h2>
      <p class="first-p">
        {{ info.headingInfo }}
        <br />
        <br />
        {{ info.seatsInfo }}
      </p>
      <div class="grid">
        <div class="text">
          <h4>Length</h4>
          <h3 :style="{ color: info.txtColor }" class="pre">
            {{ info.lenth }}
          </h3>
        </div>
        <div class="text">
          <h4>Bootcamp Starts</h4>
          <h3 :style="{ color: info.txtColor }">{{ info.startDate }}</h3>
        </div>
        <div class="text">
          <h4>Cost</h4>
          <h3 :style="{ color: info.txtColor }">{{ info.cost }}</h3>
        </div>
        <div class="text">
          <h4>Quiz Deadline</h4>
          <h3 :style="{ color: info.txtColor }">
            {{ info.deadline }}
          </h3>
        </div>
        <div class="text">
          <h4>Course Outline</h4>
          <a class="btn" :href="info.courseOutlineLink" target="_blank">
            Download PDF
          </a>
        </div>
      </div>
      <div class="grid-2 " :style="{ backgroundColor: info.bgColor }">
        <p style="text-align:left;color:white">
          {{ info.discountInfo }}
          <br />
          <br />
          {{ info.jobOppurtunity }}
        </p>

        <a :href="info.quizLink">
          <button class="btn-1">
            Take the Quiz
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      require: true,
    },
  },
}
</script>

<style scoped>
.pre {
  white-space: pre;
}
.btn {
  background-color: transparent;
  border: 1px solid #2465f3;
  color: #2465f3;
  padding: 7px 30px;
  cursor: pointer;
  font-size: 16px;
}

/* Darker background on mouse-over */
.btn:hover {
  background-color: transparent;
}
.btn-1 {
  background-color: white;
  min-width: 240px;
  min-height: 50px;
  border: none;
  color: #2465f3;
  padding: 7px 30px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 4px;
}

/* Darker background on mouse-over */
.btn-1:hover {
  background-color: #f8f8ff;
}
.grid-2 {
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  padding: 50px 150px;
}
.grid-2 p {
  padding-left: 25px;
  font: 700 1.125rem/1.5rem 'Manrope';
  color: white;
  max-width: 600px !important;
}
.container p {
  text-align: center;
  max-width: 1020px;
  margin: 0 auto;
  font: 400 1.125rem/1.4rem 'Manrope';
  color: #626367;
}
.first-p {
  text-align: center;
  max-width: 970px;
  margin: 0 auto;
  font: 400 1.125rem/1.4rem 'Manrope';
  color: #626367;
  padding-bottom: 50px;
}
.text h4 {
  font: 700 1.5rem/1.75rem 'Manrope';
  color: #29292b;
}
.text h3 {
  font: 700 1.75rem/2rem 'Manrope';
}
.header-font {
  padding-top: 100px;
  font: 800 2.25rem/2.75rem 'Manrope';
  color: #29292b;
  padding-bottom: 50px;
}
.grid {
  padding: 50px;
  background-color: white;
  margin: 0 auto;
  max-width: 1300px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
@media only screen and (max-width: 600px) {
  .grid {
    padding: 50px;
    background-color: white;
    margin: 0 auto;
    max-width: 350px;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 25px;
  }
  .grid-2 {
    display: flex;
    flex-direction: column;
    padding: 20px 15px;
  }
  .text h4 {
    font: 700 1.25rem/1.75rem 'Manrope';
  }
  .text h3 {
    font: 700 1.75rem/2.5rem 'Manrope';
  }
  .grid-2 p {
    padding-left: 0;
    padding-bottom: 25px;
  }
  .grid-2 a {
    display: flex;
    justify-content: center;
  }
}
</style>
